<template>
  <v-dialog v-model="internalValue" max-width="600">
    <v-card>
      <v-card-text class="primary white--text d-flex align-center py-2 px-4">
        <span class="font-size-md white--text">Status Notations</span>
        <v-spacer />
        <v-btn icon @click="close" class="ml-2 white--text"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-text>
      <v-card-text class="pa-4">
        <div v-for="(item, index) in statusItems" :key="index" class="my-1">
          <v-icon :color="item.color">{{ item.icon }}</v-icon>
          <span class="ml-2">{{ item.label }}</span>
          <v-divider v-if="index < statusItems.length - 1" class="my-1"></v-divider>
        </div>
        <div v-if="!statusItems.length" class="text-center title pa-5 grey--text">No status available</div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'StatusHelpDialog',
  props: {
    modelValue: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    statusItems() {
      return [
        { icon: 'mdi-timer-sand-full', color: 'info', label: this.$nova.labelsName('cycle_page', 'commentary_filter_local_commentary_awaited', 'Local commentary awaited') },
        { icon: 'mdi-timer-sand-empty', color: 'info', label: this.$nova.labelsName('cycle_page', 'commentary_filter_regional_commentary_awaited', 'Regional commentary awaited') },
        { icon: 'mdi-timer-sand-full', color: 'warning', label: this.$nova.labelsName('cycle_page', 'commentary_filter_local_commentary_awaiting_approval', 'Local commentary awaiting approval') },
        { icon: 'mdi-timer-sand-empty', color: 'warning', label: this.$nova.labelsName('cycle_page', 'commentary_filter_regional_commentary_awaiting_approval', 'Regional Commentary awaiting approval') },
        { icon: 'mdi-close-circle', color: 'error', label: this.$nova.labelsName('cycle_page', 'commentary_filter_local_commentary_rejected', 'Local Commentary rejected') },
        { icon: 'mdi-close-circle-outline', color: 'error', label: this.$nova.labelsName('cycle_page', 'commentary_filter_regional_commentary_rejected', 'Regional Commentary rejected') },
        { icon: 'mdi-check-circle', color: 'success', label: this.$nova.labelsName('cycle_page', 'commentary_filter_approved_label', 'Approved Commentary') },
        { icon: 'mdi-bookmark-off', color: 'grey', label: this.$nova.labelsName('cycle_page', 'commentary_filter_nil_value_accounts_label', 'Nil value accounts') },
        { icon: 'mdi-cash-remove', color: 'grey', label: this.$nova.labelsName('cycle_page', 'commentary_filter_immaterial_variance_label', 'Immaterial variance') },
        { icon: 'mdi-forum-remove-outline', color: 'grey', label: this.$nova.labelsName('cycle_page', 'commentary_filter_not_in_scope_label', 'Not in Scope') },
      ];
    },
  },
  methods: {
    close() {
      this.internalValue = false;
    },
  },
};
</script>
